import { render, staticRenderFns } from "./browser-not-recommended-overlay.vue?vue&type=template&id=555263be"
import script from "./browser-not-recommended-overlay.vue?vue&type=script&lang=js"
export * from "./browser-not-recommended-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555263be')) {
      api.createRecord('555263be', component.options)
    } else {
      api.reload('555263be', component.options)
    }
    module.hot.accept("./browser-not-recommended-overlay.vue?vue&type=template&id=555263be", function () {
      api.rerender('555263be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/components/site-overlay/browser-not-recommended-overlay.vue"
export default component.exports